import React from "react"
const Rank = ({name,entries})=>{
    console.log("Rank Entries",entries)
    return(
    <div>
            <p className="f3 tc b">The Magic Brain will detect the faces in yout pictures.Give it a try</p>
            <p className="f4"> Total entries by {name} is {entries}</p>
    </div>
    )
}
export default Rank;